export interface SortOption {
  value: string;
  label: string;
}

export function filterCoursesBySearch<T extends Record<string, any>>(
  courses: T[],
  searchTerm: string
): T[] {
  if (!searchTerm?.trim()) return courses;
  const term = searchTerm.toLowerCase().trim();
  return courses.filter(course => {
    const title = (course['title'] || course['name'] || '').toLowerCase();
    const description = (course['description'] || '').toLowerCase();
    return title.includes(term) || description.includes(term);
  });
}

export function sortCourses<T extends Record<string, any>>(
  courses: T[],
  field: string,
  order: 'asc' | 'desc'
): T[] {
  if (!field || courses.length <= 1) return courses;
  const sorted = [...courses];
  const dir = order === 'asc' ? 1 : -1;

  sorted.sort((a, b) => {
    const aVal = a[field];
    const bVal = b[field];

    // Nulls/undefined always sort to the end regardless of direction
    if (aVal == null && bVal == null) return 0;
    if (aVal == null) return 1;
    if (bVal == null) return -1;

    // Numeric fields
    if (typeof aVal === 'number' && typeof bVal === 'number') {
      return (aVal - bVal) * dir;
    }

    // Date fields (ISO strings)
    if (field.endsWith('At') || field.endsWith('Date') || field === 'createdAt' || field === 'updatedAt') {
      const aTime = new Date(aVal).getTime();
      const bTime = new Date(bVal).getTime();
      if (!isNaN(aTime) && !isNaN(bTime)) return (aTime - bTime) * dir;
    }

    // String fields (case-insensitive)
    const aStr = String(aVal).toLowerCase();
    const bStr = String(bVal).toLowerCase();
    return aStr.localeCompare(bStr) * dir;
  });

  return sorted;
}
